module.exports = __webpack_public_path__ + "static/media/twitter_logo_claro.eaf84692.webp";